module.exports = __webpack_public_path__ + "static/img/lock.a1e9207c.svg";